import { createAsyncThunk } from '@reduxjs/toolkit';
import { prepareNewbuildingBroker } from '../../containers/RequestFormModalWindow/utils/newbuildingBroker';
import { TCreateConsultingRequestRequest } from '../../repositories/newbuilding-flat-view-order/v2/create-consulting-request';
import { selectUtm } from '../../selectors/utm';
import { createConsultingRequest } from '../../services/consultingRequest';
import { setPhoneConfirmationRequestFailure } from '../../slices';
import { setHhConversionId } from '../../slices/cpa';
import { setRequestFailure, setRequestSubmitting, setRequestSuccess } from '../../slices/pageState';
import { IThunkApi } from '../../types/redux/store';
import { requestPhoneValidationCode } from '../phoneValidationCode';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const createConsultingRequestAction = createAsyncThunk<void, TCreateConsultingRequestRequest, IThunkApiExtended>(
  'consultingRequest/createConsultingRequest',
  async (parameters, { extra: context, dispatch, getState }) => {
    const { httpApi, logger } = context;

    dispatch(setRequestSubmitting());

    try {
      parameters.newbuildingBroker = prepareNewbuildingBroker(context.config);
      parameters.utm = selectUtm(getState()) ?? undefined;

      const response = await createConsultingRequest({ httpApi, parameters });

      dispatch(setRequestSuccess());
      dispatch(setHhConversionId({ hhConversionId: response.hhConversionId }));
    } catch (ex) {
      if (ex?.details?.missingValidationCode) {
        dispatch(requestPhoneValidationCode({ phone: parameters.phone }));

        return;
      }

      let errorText = '';
      let secondsToRetry = 0;
      if (ex?.details?.invalidCustomerPhone) {
        errorText = ex?.details?.invalidCustomerPhone;
        secondsToRetry = 0;
      }

      if (ex?.details?.invalidValidationCode) {
        errorText = ex?.details?.invalidValidationCode;
        secondsToRetry = 0;
      }

      logger.error(ex, {
        domain: 'actions/consultingRequest/createConsultingRequestAction',
      });

      dispatch(setPhoneConfirmationRequestFailure({ error: errorText, secondsToRetry }));

      dispatch(setRequestFailure());

      throw ex;
    }
  },
);
